import { render, staticRenderFns } from "./formBrandNew.vue?vue&type=template&id=30d5016c&scoped=true&"
import script from "./formBrandNew.vue?vue&type=script&lang=js&"
export * from "./formBrandNew.vue?vue&type=script&lang=js&"
import style0 from "./formBrandNew.vue?vue&type=style&index=0&id=30d5016c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30d5016c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30d5016c')) {
      api.createRecord('30d5016c', component.options)
    } else {
      api.reload('30d5016c', component.options)
    }
    module.hot.accept("./formBrandNew.vue?vue&type=template&id=30d5016c&scoped=true&", function () {
      api.rerender('30d5016c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insuranceCenter/components/formBrandNew.vue"
export default component.exports